import { css, cx } from "@emotion/css";
import {
  Tag as AriaTag,
  Button,
  TagProps as AriaTagProps,
} from "react-aria-components";

import { Text, Icon } from "@certn/cascadia-react";

import { useColors } from "../../../hooks/useColors";
import { useGetAllFocusShadows } from "../../utils";

interface TagProps extends AriaTagProps {
  isDisabled?: boolean;
}

export function _Tag(props: TagProps) {
  const { textValue, id, isDisabled } = props;
  const colors = useColors();
  const getAllFocusShadows = useGetAllFocusShadows();

  return (
    <AriaTag
      className={cx(
        styles.tag,
        css({
          background: colors["background-accent-neutral-weak"],
          cursor: isDisabled ? "initial" : "pointer",
          "&:focus-within": getAllFocusShadows(),
        })
      )}
      id={id}
      textValue={textValue}
      datatest-id={`${textValue}-tag`}
    >
      <>
        <Text style="global/label-small">{textValue}</Text>
        {!isDisabled && (
          <Button className={css({ all: "unset" })} slot="remove">
            <Icon type="mini" name="close" size="space-3" />
          </Button>
        )}
      </>
    </AriaTag>
  );
}

const styles = {
  tag: css({
    height: "var(--space-5)",
    width: "fit-content",
    display: "flex",
    alignItems: "center",
    gap: "var(--space-1)",
    padding: "var(--space-05) var(--space-1)",
    borderRadius: "var(--border-radius-2)",
    outline: "none",
  }),
};
